var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-bar popbox",class:{show:_vm.showSlide},attrs:{"id":"slide-bar"},on:{"click":function($event){return _vm.closeSlideBar()}}},[_c('iframe',{attrs:{"src":_vm.src,"id":"user_center"}}),_c('div',{staticClass:"opration"})])
}
var staticRenderFns = []

export { render, staticRenderFns }